<!-- TODO: snap to top when yPosition is below 20 -->
<div
  id="app-header-wrapper"
  [class.shrinked]="isMobileScreen || yPosition > 20">
  <header
    id="header"
    class="row c-row--header u-t-divider">
    <div class="col">
      <div class="o-grid--small flex middle nowrap header-wrapper">
        <div class="o-grid__item nav-header__logo">
          <a routerLink="{{ routeNameConstants.ROOT }}"
            ><img
              class="c-logo"
              [src]="brandingService.getBrandLogo()"
              alt="Where Is My Tool"
          /></a>
        </div>
        <div
          *ngIf="isLoggedIn()"
          class="o-grid__item nav-header__item u-desktop">
          <company-select
            [class]="'header'"
            placeholder="{{ 'companyselect.placeholder' | translate }}">
          </company-select>
        </div>
        <div
          *ngIf="isLoggedIn()"
          class="o-grid__item nav-header__item u-desktop">
          <dept-select></dept-select>
        </div>
        <div class="spacer"></div>
        <div
          *ngIf="isLoggedIn()"
          class="o-grid__item nav-header__search">
          <form
            *ngIf="isSearchInputVisible"
            #f="ngForm"
            class="search-input__form"
            (ngSubmit)="onSearchSubmit()">
            <div class="search-input__group">
              <input
                #searchInput
                type="text"
                name="search"
                id="main-search"
                [(ngModel)]="quickSearch"
                class="search-input"
                [class.is-expanded]="isSearchInputExpanded"
                [placeholder]="localizationConstants.HOME_SEARCH_BY | translate"
                [disabled]="!companyService.selectedCompany" />
              <button
                #searchInputToggle
                id="tools-search"
                type="submit"
                class="button-action search-input__button search-input__expandable"
                value="Search"
                (click)="onSearchButtonClick()"
                [title]="localizationConstants.HOME_SEARCH_BY | translate">
                <mat-icon svgIcon="search"></mat-icon>
              </button>
              <button
                #searchInputToggle
                id="tools-search"
                type="submit"
                class="button-action search-input__button search-input__clickable"
                value="Search"
                (click)="showSearchModal()"
                [title]="localizationConstants.HOME_SEARCH_BY | translate">
                <mat-icon svgIcon="search"></mat-icon>
              </button>
            </div>
          </form>
        </div>
        <div
          *ngIf="isLoggedIn()"
          class="o-grid__item nav-header__actions flex action-bar">
          <div class="action-bar__button">
            <button
              routerLink="{{ routeNameConstants.SERVICE_REQUEST }}"
              type="button"
              class="button button-action"
              [matBadge]="raBasket.itemsCount"
              matBadgePosition="after"
              [matBadgeHidden]="raBasket.itemsCount === 0"
              [disabled]="!companyService.selectedCompany"
              [title]="localizationConstants.HEADER_SERVICE_REQUEST | translate">
              <mat-icon svgIcon="service"></mat-icon>
            </button>
          </div>
          <div class="action-bar__button">
            <button
              routerLink="{{ routeNameConstants.PURCHASE_ORDER }}"
              type="button"
              class="button button-action"
              [matBadge]="poBasket.itemsCount"
              matBadgePosition="after"
              [matBadgeHidden]="poBasket.itemsCount === 0"
              [disabled]="!companyService.selectedCompany"
              [title]="localizationConstants.HEADER_PURCHASE_ORDER | translate">
              <mat-icon svgIcon="purchase"></mat-icon>
            </button>
          </div>
          <div class="flex">
            <a
              class="button-action"
              (click)="openMenu()"
              [title]="localizationConstants.USER_SETTINGS_TITLE | translate">
              <mat-icon svgIcon="user"></mat-icon>
            </a>
          </div>
          <div class="action-bar__button">
            <a
              href="{{ brandingService.getYoutubeLink() }}"
              target="_blank">
              <button
                type="button"
                class="button button-action"
                [title]="localizationConstants.ICON_INFORMATION_TITLE | translate">
                <mat-icon svgIcon="information"></mat-icon>
              </button>
            </a>
          </div>
          <mobile-menu class="u-tablet-and-mobile flex"></mobile-menu>
          <a
            *ngIf="showLogin()"
            routerLink="{{ routeNameConstants.LOGIN }}"
            type="button"
            class="button button-secondary u-ml--alpha"
            >{{ localizationConstants.BUTTON_LOGIN | translate }}</a
          >
        </div>
      </div>
    </div>
  </header>
</div>

<nav
  class="nav-main"
  *ngIf="isLoggedIn() && companyService.selectedCompany">
  <ul class="nav-main__list">
    <li class="nav-main__item">
      <a
        class="nav-main__link"
        routerLink="{{ routeNameConstants.ROOT }}">
        <mat-icon
          class="nav-main__icon"
          aria-hidden="false"
          aria-label="Overview"
          svgIcon="home"></mat-icon>
      </a>
    </li>
    <li class="nav-main__item">
      <a
        class="nav-main__link"
        routerLink="{{ routeNameConstants.TOOLS }}"
        >{{ localizationConstants.HEADER_TOOLS | translate }}</a
      >
    </li>
    <li
      class="nav-main__item"
      *ngIf="isTechCoverEnabled()">
      <a
        class="nav-main__link"
        routerLink="{{ routeNameConstants.TECH_COVER }}"
        >{{ localizationConstants.HEADER_MY_SOFTWARE | translate }}</a
      >
    </li>
    <li class="nav-main__item">
      <a
        class="nav-main__link"
        routerLink="{{ routeNameConstants.TOOL_LOCATION }}"
        >{{ localizationConstants.HEADER_LOCATIONS | translate }}</a
      >
    </li>
    <li
      *ngIf="companyService.selectedCompany && authService.user?.allowContracts"
      class="nav-main__item">
      <a
        class="nav-main__link"
        routerLink="{{ routeNameConstants.CONTRACTS }}"
        >{{ localizationConstants.HEADER_CONTRACTS | translate }}</a
      >
    </li>
    <li
      *ngIf="companyService.selectedCompany && authService.user?.allowFieldService"
      id="field-service-link"
      class="nav-main__item">
      <a
        class="nav-main__link"
        routerLink="{{ routeNameConstants.FIELD_SERVICE }}"
        >{{ localizationConstants.HEADER_FIELD_SERVICE | translate }}</a
      >
    </li>
  </ul>
</nav>
